module.exports = __webpack_public_path__ + "static/img/fax.b7d4672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fax.png
// module id = DCbq
// module chunks = 1